import { Component } from '@angular/core';

@Component({
  selector: 'app-confirm',
  template: `<div class="app-popup-title" [innerHtml]="title | htmlSafe"></div>
<div class="app-popup-text" [innerHtml]="text | htmlSafe"></div>`,
  styles: [`.app-popup-title{font-size:20px;text-align:center;padding:30px 15px 15px}.app-popup-text{font-size:18px;text-align:center}`]
})
export class ConfirmComponent {

  title: string;
  text: string;
}
